module.exports = __webpack_public_path__ + "LCStudies_Banner.png?1a0e506a16a05e298c91d345ebd53f53";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Solution/LCStudies/LCStudies_Banner.png
// module id = 59
// module chunks = 0